import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getDriverEntriesSelector = createSelector(
  driverEntries => driverEntries.driverEntries,
  (driverEntriesById) => getArrayOfObjectValues(driverEntriesById)
);